import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-contectus',
    templateUrl: './contectus.component.html',
    styleUrl: './contectus.component.css',
    imports: [FormsModule, CommonModule]
})
export class ContectusComponent {
  contactForm = {
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  };

  successMessage: string | null = null;

  onSubmit() {
    // Perform form submission logic here (e.g., send data to an API)
    console.log('Form Submitted:', this.contactForm);

    // Show success message
    this.successMessage = 'Thank you for contacting us! We will get back to you soon.';

    // Reset form and clear the message after 5 seconds
    setTimeout(() => {
      this.successMessage = null;
      this.contactForm = {
        firstName: '',
        lastName: '',
        email: '',
        message: ''
      };
    }, 5000);
  }
}



